import { createStore } from "owa-satcheljs";
import type DrawerPaneAnchorState from "./schema/DrawerPaneAnchorState";
import type { DrawerPaneAnchorRegistration } from "./schema/DrawerPaneAnchorState";

const defaultStore: DrawerPaneAnchorState = {
    anchorMap: new Map<string, DrawerPaneAnchorRegistration>(),
};

export const getAnchorStore: () => DrawerPaneAnchorState = createStore<DrawerPaneAnchorState>("DrawerPaneAnchorStore", defaultStore);
